module.exports = __webpack_public_path__ + "img/chat.36f3b6f9.svg";